import { ResourceLicensesDocument } from "@pathwright/graphql-client/src/generated"

export default ResourceLicensesDocument
